import React, { useEffect, useRef, useState } from 'react'
import './ImageCreator.scss'
import NewHeader from '../../components/NewHeader'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Col,
  Row,
  Form,
  Select,
  Input,
  InputNumber,
  message,
  Tabs
} from 'antd'
import history from '../../history'
import ImageCard from './components/ImageCard'
import { api } from '../../services'
import styleOptions from './components/stylesLst'
import { useSelector } from 'react-redux'
import { ImageSelect } from '../../components/Form'

const { Option } = Select
const { TabPane } = Tabs
const baseUrl = process.env.REACT_APP_IMAGE_CREATION_URL
const NODE_ENV = process.env.NODE_ENV
const ImageCreator = ({ form }) => {
  const { t } = useTranslation()
  const gridRef = useRef(null)
  const selectRef = useRef(null)

  const activeOrganizationId = useSelector(
    state => state.user.info.active_organization_id
  )
  const [isLoading, setIsloading] = useState(false)
  const [jobPercentage, setPercentage] = useState(0)
  const [activeTab, setActiveTab] = useState('TEXT')
  const [isReady, setIsReady] = useState(false)
  const [isLoadingInpaint, setIsloadingInpaing] = useState(false)
  const [imageList, setImageList] = useState([])
  const [imagePropmt, setImagePrompt] = useState('')
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useEffect(() => {
    const handleDropdownPosition = () => {
      const dropdownEl = document.querySelector('.side-dropdown-menu')
      if (dropdownEl) {
        const viewportHeight = window.innerHeight
        const dropdownRect = dropdownEl.getBoundingClientRect()

        if (dropdownRect.bottom > viewportHeight) {
          // If dropdown extends beyond bottom of viewport, adjust its position
          dropdownEl.style.top = `${Math.max(
            0,
            viewportHeight - dropdownRect.height
          )}px !important`
        }
      }
    }

    // Use MutationObserver to detect when dropdown is added to DOM
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          handleDropdownPosition()
        }
      })
    })

    observer.observe(document.body, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [])
  useEffect(() => {
    // Check permissions
    if (
      NODE_ENV === 'production' &&
      activeOrganizationId &&
      activeOrganizationId !== 524
    ) {
      message.error(
        'You do not have access to this feature, Please contact Admin.'
      )
      history.push('/workshop')
      return
    }

    // Initialize from localStorage
    const storedList = localStorage.getItem('ICList')
    if (storedList) {
      setImageList(JSON.parse(storedList))
    }

    // Start the lambda
    startLambda()

    // window.addEventListener('beforeunload', stopLamda);
    // return () => {
    //   stopLamda()
    // }
  }, [])

  const stopLamda = async () => {
    let lastJobRes = await api.imageGeneration.fetchIGLastJob()
    if (lastJobRes && lastJobRes.data && lastJobRes.data.queue.length === 0) {
      api.imageGeneration.stopIGLambda()
      history.push('/workshop')
      localStorage.setItem('ICList', JSON.stringify([]))
    } else {
      message.error('There is an image generation in progress!')
    }
  }
  const startLambda = async () => {
    try {
      if (
        (
          await Promise.race([
            api.imageGeneration.checkIGStatus(),
            new Promise((_, reject) =>
              setTimeout(() => reject(new Error('Timeout')), 10000)
            )
          ])
        ).data === 'pong'
      )
        return setIsReady(true)
    } catch {
      localStorage.setItem('ICList', '[]')
      setImageList([])
      await api.imageGeneration.startIGLambda().catch(() => {})
    }
    setTimeout(startLambda, 15000)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const stylesLabels = values.styles
          .map(style => style.key)
          .filter(Boolean)
        const stylesKeys = values.styles.map(style => style.key).filter(Boolean)

        let data = {
          images: Array.from({ length: values.outputs }, () => ({ url: `` })),
          created_at: new Date().toISOString(),
          aspect: values.aspect.replace('*', 'x'),
          format: values.format,
          style: stylesLabels,
          performanceMode: values.performanceMode,
          prompt: values.prompt || 'Image Prompt',
          outputs: values.outputs,
          seed: values.seeds
        }

        try {
          setPercentage(0)
          setIsloading(true)
          scrollToTop()
          setImageList(prevList => [data, ...prevList])
          let payload = {
            prompt: values.prompt,
            aspect_ratios_selection: values.aspect.split(' | ')[0],
            image_number: values.outputs,
            save_extension: values.format,
            style_selections: stylesKeys,
            image_seed: values.seeds,
            performance_selection: values.performanceMode
          }

          const fetchLastJobWithRetry = async (
            maxRetries = 3,
            delay = 1000
          ) => {
            let attempts = 0

            while (attempts < maxRetries) {
              let lastJobRes = await api.imageGeneration.fetchIGLastJob()

              if (
                lastJobRes &&
                lastJobRes.data &&
                lastJobRes.data.queue.length > 0
              ) {
                return lastJobRes
              }

              attempts++
              await new Promise(resolve => setTimeout(resolve, delay))
            }

            message.error('No job found in queue, please try again!')
            setImageList(prevList => prevList.slice(1))
            setIsloading(false)
          }

          const processJob = async () => {
            try {
              api.imageGeneration.fetchImageGeneration(payload)

              await new Promise(resolve => setTimeout(resolve, 1000))

              let lastJobRes = await fetchLastJobWithRetry()

              let job_id = lastJobRes.data.queue.pop().job_id

              const pollProgress = async () => {
                try {
                  let jobPercentage = await api.imageGeneration.fetchIGProgress(
                    job_id
                  )
                  let percent = jobPercentage.data.job_progress
                  setPercentage(percent)

                  if (
                    jobPercentage &&
                    jobPercentage.data.job_status !== 'Finished'
                  ) {
                    setTimeout(pollProgress, 2000)
                  } else {
                    await new Promise(resolve => setTimeout(resolve, 500))

                    let updatedImages = jobPercentage.data.job_result.map(
                      image => ({
                        url: baseUrl + new URL(image.url).pathname,
                        seed: image.seed
                      })
                    )

                    setImageList(prevList => {
                      const updatedList = prevList.slice(1)
                      const newList = [
                        { ...data, images: updatedImages },
                        ...updatedList
                      ]
                      const finalList =
                        newList.length > 20 ? newList.slice(0, 20) : newList

                      localStorage.setItem('ICList', JSON.stringify(finalList))
                      return finalList
                    })
                    setIsloading(false)
                  }
                } catch (pollError) {
                  setImageList(prevList => prevList.slice(1))
                  setIsloading(false)
                }
              }

              pollProgress()
            } catch (error) {
              console.error('Error processing job:', error)
            }
          }

          processJob()
        } catch (error) {
          console.log('Test Error during image generation:', error)
          setImageList(prevList => prevList.slice(1))
          if (error.response) {
            message.error(`Error: ${error.response.statusText}`)
          } else if (error.request) {
            message.error('No response received from server')
          } else {
            message.error(`Error: ${error.message}`)
          }
          setIsloading(false)
        }
      } else {
        message.error('Form validation failed!')
      }
    })
  }
  const handleSubmitImage = async e => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const stylesLabels = values.styles
          .map(style => style.key)
          .filter(Boolean)
        const stylesKeys = values.styles.map(style => style.key).filter(Boolean)

        let data = {
          images: Array.from({ length: values.outputs }, () => ({ url: `` })),
          created_at: new Date().toISOString(),
          aspect: values.aspect.replace('*', 'x'),
          format: values.format,
          style: stylesLabels,
          performanceMode: values.performanceMode,
          prompt: values.prompt || 'Image Prompt',
          outputs: values.outputs,
          seed: values.seeds
        }

        try {
          setPercentage(0)
          setIsloading(true)
          scrollToTop()
          setImageList(prevList => [data, ...prevList])
          let payload = {
            negative_prompt: values.negative_prompt,
            prompt: values.prompt,
            image_prompts: values.image_prompts,
            aspect_ratios_selection: values.aspect.split(' | ')[0],
            image_number: values.outputs,
            save_extension: values.format,
            style_selections: stylesKeys,
            image_seed: values.seeds,
            performance_selection: values.performanceMode,
            guidance_scale: values.guidance_scale
            // advanced_params: {
            //   controlnet_softness: values.controlnet_softness
            // }
          }

          const fetchLastJobWithRetry = async (
            maxRetries = 3,
            delay = 1000
          ) => {
            let attempts = 0

            while (attempts < maxRetries) {
              let lastJobRes = await api.imageGeneration.fetchIGLastJob()

              if (
                lastJobRes &&
                lastJobRes.data &&
                lastJobRes.data.queue.length > 0
              ) {
                return lastJobRes
              }

              attempts++
              await new Promise(resolve => setTimeout(resolve, delay))
            }

            message.error('No job found in queue, please try again!')
            setImageList(prevList => prevList.slice(1))
            setIsloading(false)
          }

          const processJob = async () => {
            try {
              api.imageGeneration.fetchImagePromptGeneration(payload)

              await new Promise(resolve => setTimeout(resolve, 1000))

              let lastJobRes = await fetchLastJobWithRetry()

              let job_id = lastJobRes.data.queue.pop().job_id

              const pollProgress = async () => {
                try {
                  let jobPercentage = await api.imageGeneration.fetchIGProgress(
                    job_id
                  )
                  let percent = jobPercentage.data.job_progress
                  setPercentage(percent)

                  if (
                    jobPercentage &&
                    jobPercentage.data.job_status !== 'Finished'
                  ) {
                    setTimeout(pollProgress, 2000)
                  } else {
                    await new Promise(resolve => setTimeout(resolve, 500))

                    let updatedImages = jobPercentage.data.job_result.map(
                      image => ({
                        url: baseUrl + new URL(image.url).pathname,
                        seed: image.seed
                      })
                    )

                    setImageList(prevList => {
                      const updatedList = prevList.slice(1)
                      const newList = [
                        { ...data, images: updatedImages },
                        ...updatedList
                      ]
                      const finalList =
                        newList.length > 20 ? newList.slice(0, 20) : newList

                      localStorage.setItem('ICList', JSON.stringify(finalList))
                      return finalList
                    })
                    setIsloading(false)
                  }
                } catch (pollError) {
                  setImageList(prevList => prevList.slice(1))
                  setIsloading(false)
                }
              }

              pollProgress()
            } catch (error) {
              setImageList(prevList => prevList.slice(1))
              setIsloading(false)
              console.error('Error processing job:', error)
            }
          }

          processJob()
        } catch (error) {
          console.log('Test Error during image generation:', error)
          setImageList(prevList => prevList.slice(1))
          if (error.response) {
            message.error(`Error: ${error.response.statusText}`)
          } else if (error.request) {
            message.error('No response received from server')
          } else {
            message.error(`Error: ${error.message}`)
          }
          setIsloading(false)
        }
      } else {
        message.error('Form validation failed!')
      }
    })
  }

  const goBack = () => {
    if (isLoading || isLoadingInpaint) {
      setIsloading(false)
      setIsloadingInpaing(false)
      setImageList(prevList => prevList.slice(1))
      return
    }
    history.push('/workshop')
  }
  const deleteImage = index => {
    setImageList(prevList => {
      const finalList = prevList.filter((_, i) => i !== index)
      localStorage.setItem('ICList', JSON.stringify(finalList))
      return finalList
    })
  }
  const scrollToTop = () => {
    if (gridRef.current) {
      gridRef.current.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  return (
    <div className="ic-main">
      <div className="ic-main_header">
        <div className="ic-main_header_text">{t('v4:imageCreatorTitle')}</div>
        <NewHeader />
      </div>
      <div className="ic-main_container">
        <Row gutter={[24, 0]}>
          <Col xs={24} sm={12} md={10} lg={8}>
            <div className="ic-main_container_left">
              <div className="ic-main_container_left_title">
                {t('v4:setting_generator')}
                {isReady && (
                  <Button htmlType="submit" type={'danger'} onClick={stopLamda}>
                    {'Stop Server'}
                  </Button>
                )}
              </div>

              <div className="ic-main_container_left_form">
                <Tabs
                  defaultActiveKey={activeTab}
                  onChange={value => {
                    setImagePrompt('')
                    setActiveTab(value)
                  }}
                  animated={false}
                >
                  <TabPane tab={'Text Prompt'} key={'TEXT'}>
                    {activeTab === 'TEXT' && (
                      <Form onSubmit={handleSubmit}>
                        <Form.Item>
                          {getFieldDecorator('prompt', {
                            rules: [
                              {
                                required: true,
                                message: t('v4:enter_image_prompt')
                              }
                            ]
                          })(
                            <Input.TextArea
                              rows={4}
                              placeholder={t('v4:image_prompt')}
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>
                        <Form.Item label={t('v4:negative_prompt')}>
                          {getFieldDecorator('negative_prompt')(
                            <Input.TextArea
                              rows={4}
                              placeholder={t('v4:negative_image_prompt')}
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>
                        <Form.Item label={t('infographic:aspect_ratio')}>
                          {getFieldDecorator('aspect', {
                            initialValue: '512*512 | 1:1'
                          })(
                            <Select disabled={isLoading || isLoadingInpaint}>
                              <Option value="1024*1024 | 1:1">
                                1024x1024 | 1:1
                              </Option>
                              <Option value="512*512 | 1:1">
                                512x512 | 1:1
                              </Option>
                              <Option value="1024*576 | 16:9">
                                1024x576 | 16:9
                              </Option>
                              <Option value="1280*768 | 5:3">
                                1280x768 | 5:3
                              </Option>
                              <Option value="1024*768 | 4:3">
                                1024x768 | 4:3
                              </Option>
                              <Option value="768*1024 | 3:4">
                                768x1024 | 3:4
                              </Option>
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item label={t('v4:number_output')}>
                          {getFieldDecorator('outputs', {
                            initialValue: 1,
                            rules: [
                              {
                                required: true,
                                message: t('v4:enter_number_output')
                              }
                            ]
                          })(
                            <InputNumber
                              min={1}
                              step={1}
                              max={6}
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>

                        <Form.Item label="Styles">
                          {getFieldDecorator('styles', {
                            initialValue: [
                              {
                                key: styleOptions[0].value,
                                label: styleOptions[0].label
                              }
                            ],
                            rules: [
                              {
                                required: true,
                                message: t('v4:image_style')
                              }
                            ]
                          })(
                            <div ref={selectRef} className="ic-select-style">
                              <Select
                                showSearch
                                mode={'tags'}
                                maxTagCount={3}
                                placeholder={t('v5:please_select_style')}
                                labelInValue
                                optionLabelProp="label"
                                disabled={isLoading || isLoadingInpaint}
                                dropdownMatchSelectWidth={false}
                                dropdownClassName="side-dropdown-menu"
                                dropdownStyle={{
                                  width: '320px',
                                  maxHeight: '80vh',
                                  overflowY: 'auto'
                                }}
                                getPopupContainer={triggerNode =>
                                  triggerNode.parentNode
                                }
                              >
                                {styleOptions.map(styles => (
                                  <Option
                                    key={styles.value}
                                    value={styles.value}
                                    label={styles.label}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: '1px solid #E3E3E3',
                                        borderRadius: '1rem',
                                        gap: '1.2rem',
                                        padding: '0.6rem',
                                        marginBottom: '.6rem'
                                      }}
                                    >
                                      <img
                                        src={styles.link}
                                        alt={styles.label}
                                        style={{
                                          width: '100px',
                                          height: '100px',
                                          objectFit: 'cover'
                                        }}
                                      />
                                      <span
                                        style={{
                                          whiteSpace: 'normal',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          wordWrap: 'break-word',
                                          wordBreak: 'break-word',
                                          maxWidth: '100%',
                                          display: 'inline-block'
                                        }}
                                      >
                                        {styles.label}
                                      </span>
                                    </div>
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          )}
                        </Form.Item>
                        <Form.Item label={t('v4:output_format')}>
                          {getFieldDecorator('format', {
                            initialValue: 'png'
                          })(
                            <Select disabled={isLoading || isLoadingInpaint}>
                              <Option value="png">PNG</Option>
                              <Option value="jpeg">JPEG</Option>
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item label={t('v4:seeds')}>
                          {getFieldDecorator('seeds', {
                            initialValue: -1,
                            rules: [
                              {
                                required: true,
                                message: t('v4:enter_seeds')
                              }
                            ]
                          })(
                            <Input
                              className="seeds-imput"
                              type="number"
                              size="small"
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>

                        <Form.Item label={t('v4:performance_mode')}>
                          {getFieldDecorator('performanceMode', {
                            initialValue: 'Speed'
                          })(
                            <Select disabled={isLoading || isLoadingInpaint}>
                              <Option value="Quality">{t('v4:quality')}</Option>
                              <Option value="Speed">{t('v4:speed')}</Option>
                              <Option value="Balanced">
                                {t('v4:balanced')}
                              </Option>
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item>
                          <div className="button-group">
                            <Button
                              htmlType="submit"
                              type="primary"
                              loading={isLoading || !isReady}
                              disabled={isLoadingInpaint}
                            >
                              {isReady ? 'Generate Image' : 'Getting ready...'}
                            </Button>
                          </div>
                        </Form.Item>
                      </Form>
                    )}
                  </TabPane>
                  <TabPane tab={'Image Prompt'} key={'IMAGE'}>
                    {activeTab === 'IMAGE' && (
                      <Form onSubmit={handleSubmitImage}>
                        <Form.Item>
                          {getFieldDecorator('prompt')(
                            <Input.TextArea
                              rows={4}
                              placeholder={t('v4:image_prompt')}
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>
                        <Form.Item label={t('v4:negative_prompt')}>
                          {getFieldDecorator('negative_prompt')(
                            <Input.TextArea
                              rows={4}
                              placeholder={t(
                                'v4:negative_image_promptnegative_image_prompt'
                              )}
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>
                        <Form.Item label={t('v4:guidance_scale')}>
                          {getFieldDecorator('guidance_scale', {
                            initialValue: 4,
                            rules: [
                              {
                                required: true,
                                message: t('v4:enter_guidance')
                              }
                            ]
                          })(
                            <InputNumber
                              min={1}
                              step={1}
                              max={15}
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>
                        {/* <Form.Item label="Controlnet Softness">
                          {getFieldDecorator('controlnet_softness', {
                            initialValue: 0.25,
                            rules: [
                              {
                                required: true,
                                message: 'Please enter controlnet softness'
                              }
                            ]
                          })(
                            <InputNumber
                              min={0}
                              step={0.01}
                              max={1}
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item> */}
                        <Form.Item>
                          {getFieldDecorator('image_prompts', {
                            rules: [
                              {
                                required: true,
                                message: t('v4:select_image')
                              }
                            ]
                          })(
                            <ImageSelect
                              form={form}
                              isCropDisabled
                              required={false}
                              label={t('v4:image_prmt')}
                              coverInput={imagePropmt}
                              isClearImage
                              onClearImage={() => {
                                setFieldsValue({ image_prompts: [] })
                                setImagePrompt('')
                              }}
                              onCoverChange={cover => {
                                setFieldsValue({
                                  image_prompts: [
                                    {
                                      cn_img: cover.link,
                                      cn_stop: 0,
                                      cn_weight: 0,
                                      cn_type: 'ImagePrompt'
                                    }
                                  ]
                                })
                                setImagePrompt(cover)
                              }}
                            />
                          )}
                        </Form.Item>

                        <Form.Item label={t('infographic:aspect_ratio')}>
                          {getFieldDecorator('aspect', {
                            initialValue: '512*512 | 1:1'
                          })(
                            <Select disabled={isLoading || isLoadingInpaint}>
                              <Option value="1024*1024 | 1:1">
                                1024x1024 | 1:1
                              </Option>
                              <Option value="512*512 | 1:1">
                                512x512 | 1:1
                              </Option>
                              <Option value="1024*576 | 16:9">
                                1024x576 | 16:9
                              </Option>
                              <Option value="1280*768 | 5:3">
                                1280x768 | 5:3
                              </Option>
                              <Option value="1024*768 | 4:3">
                                1024x768 | 4:3
                              </Option>
                              <Option value="768*1024 | 3:4">
                                768x1024 | 3:4
                              </Option>
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item label="Number of Outputs">
                          {getFieldDecorator('outputs', {
                            initialValue: 1,
                            rules: [
                              {
                                required: true,
                                message: 'Please enter number of outputs'
                              }
                            ]
                          })(
                            <InputNumber
                              min={1}
                              step={1}
                              max={6}
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>

                        <Form.Item label="Styles">
                          {getFieldDecorator('styles', {
                            initialValue: [
                              {
                                key: styleOptions[0].value,
                                label: styleOptions[0].label
                              }
                            ],
                            rules: [
                              {
                                required: true,
                                message: t('v4:image_style')
                              }
                            ]
                          })(
                            <div ref={selectRef} className="ic-select-style">
                              <Select
                                showSearch
                                mode={'tags'}
                                maxTagCount={3}
                                placeholder={t('v5:please_select_style')}
                                labelInValue
                                optionLabelProp="label"
                                disabled={isLoading || isLoadingInpaint}
                                dropdownMatchSelectWidth={false}
                                dropdownClassName="side-dropdown-menu"
                                dropdownStyle={{
                                  width: '320px',
                                  maxHeight: '80vh',
                                  overflowY: 'auto'
                                }}
                                getPopupContainer={triggerNode =>
                                  triggerNode.parentNode
                                }
                              >
                                {styleOptions.map(styles => (
                                  <Option
                                    key={styles.value}
                                    value={styles.value}
                                    label={styles.label}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        border: '1px solid #E3E3E3',
                                        borderRadius: '1rem',
                                        gap: '1.2rem',
                                        padding: '0.6rem',
                                        marginBottom: '.6rem'
                                      }}
                                    >
                                      <img
                                        src={styles.link}
                                        alt={styles.label}
                                        style={{
                                          width: '100px',
                                          height: '100px',
                                          objectFit: 'cover'
                                        }}
                                      />
                                      <span
                                        style={{
                                          whiteSpace: 'normal',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          wordWrap: 'break-word',
                                          wordBreak: 'break-word',
                                          maxWidth: '100%',
                                          display: 'inline-block'
                                        }}
                                      >
                                        {styles.label}
                                      </span>
                                    </div>
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          )}
                        </Form.Item>
                        <Form.Item label="Output Format">
                          {getFieldDecorator('format', {
                            initialValue: 'png'
                          })(
                            <Select disabled={isLoading || isLoadingInpaint}>
                              <Option value="png">PNG</Option>
                              <Option value="jpeg">JPEG</Option>
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item label={t('v4:seeds')}>
                          {getFieldDecorator('seeds', {
                            initialValue: -1,
                            rules: [
                              {
                                required: true,
                                message: t('v4:enter_seeds')
                              }
                            ]
                          })(
                            <Input
                              className="seeds-imput"
                              type="number"
                              size="small"
                              readOnly={isLoading || isLoadingInpaint}
                            />
                          )}
                        </Form.Item>

                        <Form.Item label={t('v4:performance_mode')}>
                          {getFieldDecorator('performanceMode', {
                            initialValue: 'Speed'
                          })(
                            <Select disabled={isLoading || isLoadingInpaint}>
                              <Option value="Quality">{t('v4:quality')}</Option>
                              <Option value="Speed">{t('v4:speed')}</Option>
                              <Option value="Balanced">
                                {t('v4:balanced')}
                              </Option>
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item>
                          <div className="button-group">
                            <Button
                              htmlType="submit"
                              type="primary"
                              loading={isLoading || !isReady}
                              disabled={isLoadingInpaint}
                            >
                              {isReady ? 'Generate Image' : 'Getting ready...'}
                            </Button>
                          </div>
                        </Form.Item>
                      </Form>
                    )}
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </Col>
          <Col xs={24} sm={12} md={14} lg={16}>
            <div
              ref={gridRef}
              className={`ic-main_container_right ${activeTab === 'IMAGE' &&
                'image-prompt'}`}
            >
              {imageList.length <= 0 && (
                <div style={{ textAlign: 'center' }}>
                  {t('v4:generate_image_list_empty')}
                </div>
              )}
              {imageList.map((image, i) => {
                return (
                  <ImageCard
                    jobPercentage={jobPercentage}
                    key={i}
                    data={image}
                    isLoading={isLoading | isLoadingInpaint}
                    imageIndex={i}
                    deleteImage={deleteImage}
                  />
                )
              })}
            </div>
          </Col>
        </Row>
      </div>
      <div className="ic-main_footer">
        <Button
          className="close-btn"
          shape="round"
          size="large"
          onClick={goBack}
        >
          {isLoading || isLoadingInpaint
            ? t('buttons:cancel')
            : t('buttons:close')}
        </Button>
      </div>
    </div>
  )
}

export default Form.create()(ImageCreator)
